module.exports = __webpack_public_path__ + "img/group4.07e53582.png";